//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import NsSelect from '../../NsSelect.vue';

import { PropsMixin, RulesMixin, ModelMixin } from '../mixins';

export default {
  name: 'NsInputSelectField',
  components: {
    NsSelect,
  },
  mixins: [PropsMixin, RulesMixin, ModelMixin({ deep: false })],
  props: {
    /**
     * Field value
     * @type {string}
     */
    value: {
      type: String,
    },
  },
};
